import React from "react";
import Page, { PageType } from "@episerver/spa-core/Page";
import ContentArea from "@episerver/spa-core/Components/ContentArea";
import TypeMapper from "app/Models/Content/TypeMapper";
export default class StartPage extends Page {
    constructor() {
        super(...arguments);
        this.pageType = PageType.Home;
    }
    render() {
        let t = new TypeMapper();
        // console.log(t);
        t.createInstanceAsync(this.props.data).then(i => {
            // console.log(i);
            // console.log(i.getPropertyType("mainContentArea"));
        });
        return [
            React.createElement(ContentArea, { key: 'mainContentArea', context: this.props.context, data: this.props.data.mainContentArea, propertyName: 'mainContentArea', addContainer: true }),
        ];
    }
}
